import { PageTemplate, HeaderTemplate, ButtonLink } from "../styles";

const ErrorPage = () => {
  return (
    <>
      <HeaderTemplate>
        <div className="header flex-header">
          <div className="title">
            <h1>Something went wrong.</h1>
          </div>
        </div>
      </HeaderTemplate>
      <PageTemplate>
        <div>error message goes here</div>
      </PageTemplate>
    </>
  );
};

export default ErrorPage;
